module.exports = {

  /**
   * write img element with error to track exceptions in kibana
   * @param key
   * @param message
   * @return {HTMLImageElement}
   */
  imgTrack(key,message) {
    let
      today = new Date(),
      date = today.getFullYear()+'_'+(today.getMonth()+1)+'_'+today.getDate(),
      time = today.getHours() + "_" + today.getMinutes() + "_" + today.getSeconds(),
      dateTime = date+'-'+time,
      src = '/comun/img/dtm-track.jpg',
      querystring = encodeURI('key='+key+'&datetime='+dateTime+'&message='+message),
      img = document.createElement('img')
    ;
    img.src = src+'?'+querystring;
    return img;
  },
  exportRootVars() {
    for (let key in window.vocento.tracking.root) {
      if (vocento.tracking.root.hasOwnProperty(key)) {
        window[key] = vocento.tracking.root[key];
      }
    }
  },
  exportComscoreVars() {
    /** solo exportamos algunas variables, ya que VTM tiene prioridad sobre las vocvars y pisariamos sus valores */
    window.voc_top    = window.vocento.tracking.comscore.voc_top;
    window.voc_site   = window.vocento.tracking.comscore.voc_site;
    window.voc_tcnew  = window.vocento.tracking.comscore.voc_tcnew;
    window.voc_tc     = window.vocento.tracking.comscore.voc_tc;
    window.voc_se     = window.vocento.tracking.comscore.voc_se;
    window.voc_au     = window.vocento.tracking.comscore.voc_au;
    window.voc_s1     = window.vocento.tracking.comscore.voc_s1;
    window.voc_s2     = window.vocento.tracking.comscore.voc_s2;
    window.voc_s3     = window.vocento.tracking.comscore.voc_s3;
    window.voc_s4     = window.vocento.tracking.comscore.voc_s4;
  }
};



// WEBPACK FOOTER //
// ./src/tracking/trackUtils.js